import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=1803db78&scoped=true&"
import script from "./Details.vue?vue&type=script&lang=js&"
export * from "./Details.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/content.scss?vue&type=style&index=0&id=1803db78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1803db78",
  null
  
)

export default component.exports